import Type from "../Type";

const initState = {
    menuDiaGioi: null,
    huyenselect: null,
    xaselect: null
}

const DiaGioi = (state = initState, { type, route, value }) => {
    if (type === Type.SET_DIAGIOI) {
        return {
            ...state,
            [route]: value
        }
    }
    // else if (type === Type.CLEAR_MAKER)
    //     return  {
    //         ...state,
    //         pickedPolygon:[],
    //         makerPosition:{}
    //     }
    else
        return state;
}

export default DiaGioi
